// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Desks_tabs__2_He5"};